import { request } from './client';
import type { Hit, HitResult, RecordHitInput, RecordCustomHitInput, UpdateHitInput } from '../types';

export const hitsApi = {
  // Period-based hits (Q1, Q2, Q3, Q4, Final)
  async getAll(boardId: string): Promise<Hit[]> {
    return request<Hit[]>(`/api/squareup/boards/${boardId}/hits`);
  },

  async record(boardId: string, input: RecordHitInput): Promise<HitResult> {
    return request<HitResult>(`/api/squareup/boards/${boardId}/hits`, {
      method: 'POST',
      body: input,
    });
  },

  async update(boardId: string, hitId: string, input: UpdateHitInput): Promise<Hit> {
    return request<Hit>(`/api/squareup/boards/${boardId}/hits/${hitId}`, {
      method: 'PATCH',
      body: input,
    });
  },

  async delete(boardId: string, hitId: string): Promise<void> {
    return request<void>(`/api/squareup/boards/${boardId}/hits/${hitId}`, {
      method: 'DELETE',
    });
  },

  // Custom category hits (e.g., Passing Yards, Rush Yards)
  async getCustomHits(boardId: string): Promise<Hit[]> {
    return request<Hit[]>(`/api/squareup/boards/${boardId}/custom-hits`);
  },

  async recordCustomHit(boardId: string, input: RecordCustomHitInput): Promise<HitResult> {
    return request<HitResult>(`/api/squareup/boards/${boardId}/custom-hits`, {
      method: 'POST',
      body: input,
    });
  },
};
